import type { ClaimState, SpecAttribute } from '../types/catalog'

export const CLAIM_LABELS: Record<ClaimState, string> = {
  source_verified: 'From manufacturer spec', expert_reviewed: 'Expert reviewed', conflicting: 'Sources disagree', draft: 'Not yet verified',
}
export const SPEC_COLUMNS: { key: SpecAttribute; label: string }[] = [
  { key: 'raw_weight_g', label: 'Raw weight' }, { key: 'torque_deg', label: 'Torque' },
  { key: 'tip_diameter_in', label: 'Tip diameter' }, { key: 'butt_diameter_in', label: 'Butt diameter' },
  { key: 'length_in', label: 'Length' }, { key: 'frequency_cpm', label: 'Frequency (CPM)' }, { key: 'bend_point', label: 'Bend point' },
]

export function specText(value: number | string | null, unit: string | null, attribute?: string): string {
  if (value === null) return '—'
  const isDiameter = attribute === 'tip_diameter_in' || attribute === 'butt_diameter_in'
  const text = typeof value === 'number'
    ? isDiameter ? value.toFixed(3).replace(/^(-?)0\./, '$1.') : value.toLocaleString('en-US', { maximumFractionDigits: 6 })
    : value
  return unit ? `${text} ${unit === 'deg' ? '°' : unit}` : text
}

export function sourceUrl(value: string | null): string | null {
  if (!value) return null
  try {
    const url = new URL(value)
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null
  } catch { return null }
}

export function retrievalDate(value: string | null): string {
  if (!value || Number.isNaN(new Date(value).getTime())) return 'Retrieval date unavailable'
  return `Retrieved ${new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeZone: 'UTC' }).format(new Date(value))}`
}
